function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.3 14H14.7C13.4274 14 12.7911 14 12.396 14.3662C12.0009 14.7325 12 15.3227 12 16.5022V17.1156C12 18.0374 12 18.4987 12.234 18.8809C12.468 19.2632 12.8937 19.5014 13.7478 19.9761L16.3695 21.4339C16.9419 21.7521 17.229 21.9112 17.4342 22.0872C17.8608 22.4525 18.1236 22.8828 18.2424 23.4117C18.3 23.6641 18.3 23.961 18.3 24.5539V26.9273C18.3 27.7353 18.3 28.1397 18.5268 28.4544C18.7536 28.7699 19.1568 28.9255 19.9614 29.2366C21.6525 29.8891 22.4976 30.2153 23.0988 29.8437C23.7 29.4722 23.7 28.6242 23.7 26.9264V24.553C23.7 23.961 23.7 23.6641 23.7576 23.4108C23.8706 22.8927 24.1553 22.4266 24.5667 22.0863C24.771 21.9112 25.0581 21.7521 25.6305 21.433L28.2522 19.9752C29.1054 19.5014 29.5329 19.2641 29.766 18.8818C30 18.4996 30 18.0374 30 17.1147V16.5014C30 15.3227 30 14.7325 29.604 14.3662C29.2098 14 28.5735 14 27.3 14Z",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterone);
export default __webpack_public_path__ + "static/media/filterone.b9745579d9782d62fd25265ac862664d.svg";
export { ForwardRef as ReactComponent };